import React from "react";

function Services() {
  return (
    <main>

      {/* ===================== HERO ===================== */}
      <section className="bg-dark position-relative pt-xl-8 pb-0 overflow-hidden">

        <div className="position-absolute top-0 start-0 mt-n9 ms-n5">
          <img src="assets/images/elements/grad-shape/blur-decoration.svg" className="blur-7 opacity-2" alt="Grad shape" />
        </div>
        <div className="position-absolute top-0 start-50 mt-n9 ms-n9">
          <img src="assets/images/elements/grad-shape/blur-decoration.svg" className="blur-8 opacity-1" alt="Grad shape" />
        </div>

        <div className="container position-relative pt-4 pt-sm-5" data-bs-theme="dark">
          <div className="row">

            <div className="col-md-7 col-lg-5 text-center text-md-start">
              <nav className="mb-2 d-flex justify-content-center justify-content-md-start" aria-label="breadcrumb">
                <ol className="breadcrumb pt-0">
                  <li className="breadcrumb-item"><a href="/">Home</a></li>
                  <li className="breadcrumb-item active" aria-current="page">Services</li>
                </ol>
              </nav>
              <h1 className="mb-4">Our Professional Services</h1>
              <a href="/contact" className="btn btn-white mb-0">
                <i className="bi bi-telephone me-2"></i>Contact our experts
              </a>
            </div>

            <div className="col-sm-10 col-md-5 ms-auto mt-5 mt-md-0">
              <img src="assets/images/elements/service-hero.png" alt="hero image" />
            </div>

          </div>
        </div>

        {/* Wave divider — xml:space removed, style as object (fix #1 & #2) */}
        <span>
          <svg
            className="position-absolute bottom-0 start-0 mb-n1 mb-md-n6"
            viewBox="0 0 1950 237"
            style={{ enableBackground: "new 0 0 1950 237" }}
          >
            <path className="fill-body" d="M1949.5,236.4H0v-164c717.2-131.2,1598.5-54.7,1949.5,0V236.4z" />
          </svg>
        </span>
      </section>

      {/* ===================== SERVICES GRID ===================== */}
      <section className="position-relative pt-6 pt-xxl-0">
        <div className="container">
          <div className="row g-4 g-lg-5">

            {[
              { icon: "development.png", title: "Web design & Development",   badge: null,  link: "/webdev",            items: ["Custom website design", "E-commerce solutions", "Website maintenance and support"] },
              { icon: "marketing.png",   title: "Digital marketing solutions", badge: null,  link: "/digital-marketing", items: ["Fundamentals of SEO", "Social media marketing", "Pay-Per-Click"] },
              { icon: "brand.png",       title: "Brand strategy & Identity",   badge: "New", link: "/brand-strategy",    items: ["Logo design", "Brand strategy", "Visual identity"] },
              { icon: "database.png",    title: "Database analysis",           badge: null,  link: "/database-analysis", items: ["Data collection and management", "Data analysis", "Reporting and visualization"] },
              { icon: "consulting.png",  title: "Consulting services",         badge: null,  link: "/consulting",        items: ["Business strategy", "Technology consulting", "Operational improvement"] },
              { icon: "app-dev.png",     title: "Mobile app development",      badge: null,  link: "/mobile-app",        items: ["Custom app design & development", "Cross-Platform solutions", "Usability testing"] },
            ].map((s, i) => (
              <div className="col-md-6 col-xl-4" key={i}>
                <div className="card card-bg-grad-hover card-content-hover bg-secondary bg-opacity-75 h-100 p-4 p-sm-5">

                  {s.badge && (
                    <div className="badge bg-dark position-absolute top-0 end-0 m-4">{s.badge}</div>
                  )}

                  <div className="card-header bg-transparent p-0 pb-5">
                    <img src={`assets/images/services/3d-icon/${s.icon}`} className="h-70px" alt="icon" />
                  </div>

                  <div className="card-footer bg-transparent mt-auto p-0">
                    <h6 className="mb-3">{s.title}</h6>
                    <ul className="ps-3 mb-0">
                      {s.items.map((item, j) => (
                        <li className="mb-2" key={j}>{item}</li>
                      ))}
                    </ul>
                  </div>

                  <div className="hover-content d-flex justify-content-center align-items-center position-absolute top-50 start-50 translate-middle">
                    <a className="btn btn-white icon-link icon-link-hover mb-0 stretched-link" href={s.link}>
                      Explore service<i className="bi bi-arrow-right"></i>
                    </a>
                  </div>

                </div>
              </div>
            ))}

          </div>

          <p className="mb-0 mt-5 text-center heading-color">
            🔥 Let's create something great with Arix Automation.{' '}
            <a href="/contact" className="fw-bold hover-underline-animation heading-color">Got a project in mind?</a>
          </p>
        </div>
      </section>

      {/* ===================== WHY CHOOSE US ===================== */}
      <section className="pt-0">
        <div className="container">
          <div className="row">

            <div className="col-md-6 position-relative">
              <div className="position-absolute top-0 start-0 ms-xl-5">
                <img src="assets/images/elements/rocket-02.png" className="h-150px rotate-335" alt="rocket image" />
              </div>

              <div className="row ps-xl-7">
                <div className="col-sm-8">
                  <img src="assets/images/about/13.jpg" className="rounded-pill" alt="" />
                </div>
                <div className="col-sm-4 col-md-8 col-lg-5 mt-auto ms-lg-n5 mb-5">
                  <div className="card shadow rounded text-center p-0">
                    <div className="card-body p-3">
                      <h6 className="h1">4.8</h6>
                      <ul className="list-inline d-flex justify-content-center gap-2 mb-1">
                        <li className="list-inline-item me-0"><i className="bi bi-star-fill text-warning"></i></li>
                        <li className="list-inline-item me-0"><i className="bi bi-star-fill text-warning"></i></li>
                        <li className="list-inline-item me-0"><i className="bi bi-star-fill text-warning"></i></li>
                        <li className="list-inline-item me-0"><i className="bi bi-star-fill text-warning"></i></li>
                        <li className="list-inline-item me-0"><i className="bi bi-star-half text-warning"></i></li>
                      </ul>
                      <span>2855 Reviews</span>
                    </div>
                    <div className="card-footer bg-dark p-3">
                      <img src="assets/images/elements/trustpilot-light.svg" className="h-30px" alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-md-6 col-lg-5 ms-auto mt-5 mt-md-0">
              <h2>Why choose us?</h2>

              <div className="accordion accordion-icon accordion-border-bottom mt-5" id="accordionFaq">

                {[
                  { id: 1, title: "Rapid prototype development", open: true,  body: "Our expert team delivers a functional prototype within 24 hours, ensuring rapid progress and immediate feedback." },
                  { id: 2, title: "Client-Centric approach",      open: false, body: "We provide a range of tools, guides, and best practices to help you create designs, websites." },
                  { id: 3, title: "24/7 tech & business support",  open: false, body: "We provide a range of tools, guides, and best practices to help you create designs, websites." },
                ].map((item) => (
                  <div className="accordion-item mb-3" key={item.id}>
                    <div className="accordion-header font-base" id={`heading-${item.id}`}>
                      <button
                        className={`accordion-button fw-semibold rounded${item.open ? '' : ' collapsed'}`}
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${item.id}`}
                        aria-expanded={item.open}
                        aria-controls={`collapse-${item.id}`}
                      >
                        <span className="lead">{item.title}</span>
                      </button>
                    </div>
                    <div
                      id={`collapse-${item.id}`}
                      className={`accordion-collapse collapse${item.open ? ' show' : ''}`}
                      aria-labelledby={`heading-${item.id}`}
                      data-bs-parent="#accordionFaq"
                    >
                      <div className="accordion-body pb-0">{item.body}</div>
                    </div>
                  </div>
                ))}

              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ===================== CONTACT FORM ===================== */}
      <section className="bg-secondary-grad position-relative overflow-hidden">

        <div className="position-absolute bottom-0 start-0 mb-n9 d-none d-sm-block">
          <img src="assets/images/elements/grad-shape/10.png" className="rotate-270 h-500px h-lg-700px" alt="decoration shape" />
        </div>

        <div className="container position-relative">
          <div className="row g-4">

            <div className="col-lg-5">
              <h2 className="mb-3">Let's level up your brand with Arix Automation</h2>
              <p>Reach us anytime at <a href="mailto:info@arixautomation.com">info@arixautomation.com</a></p>
            </div>

            <div className="col-lg-6 ms-auto">
              <form className="row form-border-transparent g-3">
                <div className="col-md-6">
                  <label className="form-label">Your name</label>
                  <input type="text" className="form-control" placeholder="Full name" />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Email address</label>
                  <input type="email" className="form-control" placeholder="name@example.com" />
                </div>
                <div className="col-12">
                  <label className="form-label">Subject</label>
                  <input type="text" className="form-control" placeholder="Subject name" />
                </div>
                <div className="col-12">
                  <label className="form-label">Message</label>
                  {/* style string → JSX object (fix #3) */}
                  <textarea className="form-control" placeholder="Write your message here...." style={{ height: "150px" }}></textarea>
                </div>
                <div className="col-12 d-xl-flex align-items-center gap-3 mt-4">
                  <button className="btn btn-primary text-nowrap mb-2 mb-xl-0">Send a message</button>
                  <div className="form-check">
                    <input type="checkbox" className="form-check-input border" id="exampleCheck1" />
                    <label className="form-check-label" htmlFor="exampleCheck1">
                      I agree that my data is{' '}
                      <a href="#" className="hover-underline-animation text-primary-hover">collected and stored</a>.
                    </label>
                  </div>
                </div>
              </form>
            </div>

          </div>
        </div>
      </section>

    </main>
  );
}

export default Services;
